<div class="img-comp-container w-100 h-100 position-relative grid-item-space slider-module">
    <div *ngIf="screenWidth > 1024" class="h-100 img-container" [ngClass]="{'W-100': module.element_size == 8,
    'W-50': module.element_size == 4 || module.element_size == 2,
    'W-25': module.element_size == 1}">
        <div class="img-comp-img after-image img-comp-overlay-{{i}}">
            <img [ngClass]="{'W-100': module.element_size == 8,
            'W-50': module.element_size == 4 || module.element_size == 2,
            'W-25': module.element_size == 1}" (load)="isLoadedAfter()" src="{{module.after_image}}">
        </div>
        <div class="img-comp-img before-image second-image">
            <img [ngClass]="{'W-100': module.element_size == 8,
            'W-50': module.element_size == 4 || module.element_size == 2,
            'W-25': module.element_size == 1}" (load)="isLoadedBefore()" src="{{module.before_image}}">
        </div>
    </div>
    <div *ngIf="screenWidth > 767 && screenWidth < 1024" class="h-100 img-container W-100">
        <div class="img-comp-img after-image img-comp-overlay-{{i}}">
            <img class="W-100" (load)="isLoadedAfter()" src="{{module.after_image}}">
        </div>
        <div class="img-comp-img before-image mobile-second-image">
            <img class="W-100" (load)="isLoadedBefore()" src="{{module.before_image}}">
        </div>
    </div>
    <div *ngIf="screenWidth <= 767" class="h-100 img-container W-100">
        <div class="img-comp-img after-image img-comp-overlay-{{i}}">
            <img class="W-100" (load)="isLoadedAfter()" src="{{module.after_image}}">
        </div>
        <div class="img-comp-img before-image mobile-second-image">
            <img class="W-100" (load)="isLoadedBefore()" src="{{module.before_image}}">
        </div>
    </div>
    <div class="view-port-detect"
        inViewport
        [inViewportOptions]="{ threshold: [0] }"
        (inViewportAction)="onIntersection($event)">

    </div>
    <div class="preloader" [ngStyle]="{'background':preloader_color}" [ngClass]="{'fade-out':postLoaded}">
    </div>
</div>